'use strict';
const angular = require('angular');

export class imageContactBlockComponent {
  constructor(MailsService, dialogs) {
    'ngInject';
    this.MailsService = MailsService;
    this.dialogs = dialogs;
  }

  submitContactForm() {
    this.MailsService.contact({
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      phone: this.phone,
      message: this.message
    }, () => {
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.phone = '';
      this.message = '';

      this.dialogs.notify("Your message has been sent","Your message has been sent.<br/>Thank you for contacting us!");
    });
  }
}

export default angular.module('conduuApp.nifty.imageContactBlock', [])
  .component('niftyImageContactBlock', {
    template: require('./image-contact-block.html'),
    bindings: {
      image: '@',
      title: '@',
      description: '@',
      class: '@'
    },
    controller: imageContactBlockComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/nifty/image-contact-block/image-contact-block.component.js